import { MCause } from './cause.model';
import { IshikawaItem } from '../interfaces/treatment';

export class MIshikawaItem{
    public title: MCause;
    public causes: MCause[] = [];
    public input: string = '';
    public editing: boolean =  false;

    constructor(title: MCause, causes: MCause[]){
        this.title = title;
        causes.forEach(cause => {
            this.causes.push(new MCause({regular:cause}))
        });
    }
}